const SRC = {
  horizontal: { blue: "/brand/logo-horizontal-azul.png", white: "/brand/logo-horizontal-branca.png", mist: "/brand/logo-horizontal-gelo.png" },
  vertical: { white: "/brand/logo-vertical-branca.png", mist: "/brand/logo-vertical-gelo.png" },
  symbol: { blue: "/brand/simbolo-azul.png", white: "/brand/simbolo-gelo.png" },
};

const WIDTH = { horizontal: 190, vertical: 170, symbol: 44 };

export const Logo = ({ variant = "horizontal", tone = "blue", scale = 1, className = "", ...rest }) => {
  const set = SRC[variant];
  const src = set[tone] || set.white;
  return (
    <img src={src} alt="Clube do Contemplado" width={Math.round(WIDTH[variant] * scale)} draggable={false}
      className={`h-auto select-none ${className}`} {...rest} />
  );
};

export const Watermark = ({ className = "" }) => (
  <div aria-hidden="true" className={`pointer-events-none absolute ${className}`}>
    <img src="/brand/simbolo-gelo.png" alt="" width={620} className="h-auto opacity-[0.08]" draggable={false} />
  </div>
);
